import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { RadioButton, RadioButtonChangeParams } from "primereact/radiobutton";
import classes from "./DenyReasonPopup.module.scss";
import { UseMutationResult, useQuery } from "@tanstack/react-query";
import { requests } from "../../../../../../services/http-common";
import { useMemo } from "react";
import { If } from "../../../../../../components/If/If";
import { InputTextarea } from "primereact/inputtextarea";

type DenyReasonPopupProps = {
  onHide: () => void;
  updateLeadStatus: UseMutationResult;
};

export const DenyReasonPopup = ({
  onHide,
  updateLeadStatus,
}: DenyReasonPopupProps) => {
  const [reasonId, setReasonId] = useState<number | null>(null);
  const [reasonText, setReasonText] = useState("");
  const [error, setError] = useState("");

  const { mutate, isLoading } = updateLeadStatus;

  const { data } = useQuery({
    queryKey: ["deny-reason-types"],
    queryFn: () => {
      return requests.get(`/denied-reason-type`);
    },
  });

  const submit = () => {
    if (reasonId === null && !reasonText) {
      setError("Field is reqiured");
      return;
    }
    mutate({
      status: "DENIED",
      reasonTypeId: reasonId,
      reasonFreeText: reasonText,
    });
  };

  const deleteProductDialogFooter = (
    <div className={classes.actions}>
      <Button
        label="Done"
        className={classes.button}
        onClick={submit}
        disabled={isLoading}
      />
    </div>
  );

  const denyReasonOptions = useMemo(() => {
    if (!data) return [];
    const options = data.result.map((reason: any) => ({
      label: reason.name,
      value: reason.id,
    }));
    return [...options, { label: "Other", value: null }];
  }, [data]);

  const handleRadioChange = (e: RadioButtonChangeParams) => {
    setReasonId(e.value);
    setError("");
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setReasonText(e.target.value);
    setError("");
  };

  return (
    <Dialog
      visible={true}
      style={{ width: "450px" }}
      header="Select reason:"
      modal
      footer={deleteProductDialogFooter}
      onHide={onHide}
      draggable={false}
    >
      <div className={classes.content}>
        <div className={classes.options}>
          {denyReasonOptions.map((option) => (
            <div className={classes.field} key={option.label}>
              <RadioButton
                inputId={option.label}
                name={option.label}
                value={option.value}
                checked={reasonId === option.value}
                onChange={handleRadioChange}
              />
              <label htmlFor={option.label}>{option.label}</label>
            </div>
          ))}
        </div>

        <If condition={reasonId === null}>
          <div className={classes.textAreaContainer}>
            <InputTextarea
              value={reasonText}
              onChange={handleInputChange}
              autoResize
              placeholder="Let us know, why you are rejecting the lead."
              rows={5}
            />
            <span className={classes.error}>{error}</span>
          </div>
        </If>
      </div>
    </Dialog>
  );
};
